import React, { useContext, useEffect, useState } from 'react';
import { ELSInlineLoader } from '@els/els-ui-common-react';
import { FlashcardDto } from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';
import { AppContext } from '../app/AppProvider.component';
import { fetchFlashcardsAction } from '../app/app-state-actions.utilities';
import { FlashcardPlayer } from '../flashcard-player/FlashcardPlayer.component';

export type FlashcardsPanelProps = {
  botEntryId: number;
};

type FlashcardsPanelState = {
  flashcards: FlashcardDto[];
  isLoading: boolean;
  errorMessage: string;
};

const defaultState: FlashcardsPanelState = {
  flashcards: null,
  isLoading: false,
  errorMessage: null,
};

const FlashcardsPanel = (props: FlashcardsPanelProps): JSX.Element => {

  const {
    appState,
    appStateRef,
    setAppState
  } = useContext(AppContext);

  const [state, setState] = useState<FlashcardsPanelState>(defaultState);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      flashcards: null,
      errorMessage: null,
    }));

    fetchFlashcardsAction({
      appState,
      appStateRef,
      setAppState,
      botEntryId: props.botEntryId,
    })
      .then((response) => {
        if (!response.flashcards.length) {
          setState((prevState) => ({
            ...prevState,
            flashcards: null,
            isLoading: false,
            errorMessage: 'Unable to generate flashcards. Please try asking for flashcards again in a new message.',
          }));
        } else {
          setState((prevState) => ({
            ...prevState,
            flashcards: response.flashcards,
            isLoading: false,
            errorMessage: null,
          }));
        }
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.message || 'Failed to load flashcards';
        setState((prevState) => ({
          ...prevState,
          flashcards: null,
          isLoading: false,
          errorMessage,
        }));
      });
  }, [props.botEntryId]);

  if (state.isLoading) {
    return (
      <div className="u-els-padding">
        <ELSInlineLoader />
        <div className="u-els-margin-top">Loading flashcards...</div>
      </div>
    );
  }

  if (state.errorMessage) {
    return (
      <div className="u-els-padding">
        <div className="u-els-color-warn">{state.errorMessage}</div>
      </div>
    );
  }

  if (state.flashcards) {
    return <FlashcardPlayer flashcards={state.flashcards} />;
  }

  return null;
};

export default FlashcardsPanel;
